import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Monitor, Download, Clock } from 'lucide-react';
const discoveries = [{
  emoji: '🔥',
  title: 'Cómo conectarte cuando ya no tienes palabras',
  desc: 'El lenguaje del silencio que lo sagrado entiende mejor que cualquier discurso.'
}, {
  emoji: '🔥',
  title: 'Por qué el silencio interior no es abandono',
  desc: 'La presencia que no se ve pero sostiene.'
}, {
  emoji: '🔥',
  title: 'El método para soltar la ansiedad y encontrar paz',
  desc: 'Una postura interior con miles de años de historia probada.'
}, {
  emoji: '🔥',
  title: 'Señales de agotamiento espiritual antes de colapsar',
  desc: 'Tu plan de regreso personal.'
}, {
  emoji: '🔥',
  title: 'Por qué el desierto es donde la transformación ocurre',
  desc: 'La verdad que convierte el sufrimiento en maestro.'
}];
const includes = [{
  icon: '✅',
  text: 'Reflexión honesta — Escrita desde el dolor real, no desde la teoría'
}, {
  icon: '✅',
  text: 'Una verdad que ancla — Para sostenerte cuando todo tiembla'
}, {
  icon: '✅',
  text: 'Pregunta de activación — Para procesar lo que no has podido decir en voz alta'
}, {
  icon: '✅',
  text: 'Oración de un solo párrafo — Para cuando no te salen las palabras propias'
}];
export function ProductContents() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-338">
      <div className="max-w-[800px] mx-auto" data-id="element-339">
        <div className="text-center mb-6 md:mb-10" data-id="element-340">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-3 md:mb-5 relative" data-id="element-341">
            <img src="https://cdn.magicpatterns.com/uploads/c1UbddJjSLfSJgWqyUHiEX/ChatGPT_Image_23_mar_2026,_06_35_12_p.m..png" alt="Cuando Dios es lo único que te queda" className="w-24 md:w-36 rounded-lg shadow-[0_0_30px_rgba(196,164,74,0.25)] border border-[var(--accent)]/30" data-id="element-342" />
          </motion.div>
          <p className="text-[var(--accent)] uppercase tracking-widest text-xs font-bold mb-1" data-id="element-343">
            El Método
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-2" data-id="element-344">
            "Cuando Dios es lo único que te queda"
          </h2>
          <p className="text-[var(--text-muted)] uppercase tracking-widest text-xs md:text-sm mb-3" data-id="element-345">
            40 Encuentros que transforman el dolor en fe
          </p>
          <p className="text-base md:text-lg text-[var(--text-primary)] max-w-2xl mx-auto leading-relaxed" data-id="element-346">
            No es un libro para tiempos de paz.{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-347">
              Es una balsa de rescate para tu peor momento.
            </strong>
          </p>
        </div>

        {/* === DEVICE MOCKUP — STRATEGIC PERSUASION BLOCK === */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative mb-8 md:mb-12" data-id="element-348">
          {/* Ambient glow behind the mockup */}
          <div className="absolute inset-0 -inset-x-4 md:-inset-x-8 -inset-y-2 md:-inset-y-4 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(196,164,74,0.06) 0%, transparent 70%)'
        }} data-id="element-349" />

          <div className="relative bg-[var(--bg-card)] border border-[var(--accent)]/20 rounded-xl md:rounded-2xl overflow-hidden shadow-[0_8px_60px_rgba(0,0,0,0.3)]" data-id="element-350">
            {/* Top accent line */}
            <div className="h-[2px] bg-gradient-to-r from-transparent via-[var(--accent)] to-transparent" data-id="element-351" />

            <div className="p-3 sm:p-4 md:p-8" data-id="element-352">
              {/* Label */}
              <div className="text-center mb-3 md:mb-5" data-id="element-353">
                <p className="text-[var(--accent)] text-[9px] md:text-[10px] font-bold tracking-[0.2em] uppercase mb-0.5 md:mb-1" data-id="element-354">
                  Así se ve por dentro
                </p>
                <h3 className="text-base sm:text-lg md:text-2xl font-serif text-[var(--text-heading)] leading-tight" data-id="element-355">
                  Capítulo 1: El Silencio que Habla
                </h3>
                <p className="text-xs md:text-sm text-[var(--text-muted)] mt-0.5 md:mt-1 italic" data-id="element-356">
                  Vista real del contenido en tablet y móvil
                </p>
              </div>

              {/* The mockup image */}
              <motion.div className="relative flex justify-center" whileInView={{
              y: [8, 0],
              opacity: [0.8, 1]
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.3
            }} data-id="element-357">
                {/* Soft reflection/glow under image */}
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-10 md:h-16 pointer-events-none" style={{
                background: 'radial-gradient(ellipse at center, rgba(196,164,74,0.1) 0%, transparent 70%)',
                filter: 'blur(12px)'
              }} data-id="element-358" />
                <img src="https://cdn.magicpatterns.com/uploads/wPLmFh1MczV4362qAMsPGs/cover_digital.png" alt="Elegido en el Dolor — Vista previa en tablet y móvil" className="w-full max-w-[320px] sm:max-w-[420px] md:max-w-[560px] rounded-md md:rounded-lg shadow-[0_4px_40px_rgba(0,0,0,0.4)] relative z-10" data-id="element-359" />
              </motion.div>

              {/* Device compatibility badges */}
              <div className="mt-3 md:mt-6 flex flex-wrap items-center justify-center gap-2 md:gap-5" data-id="element-360">
                {[{
                icon: Smartphone,
                label: 'Celular'
              }, {
                icon: Monitor,
                label: 'Tablet / PC'
              }, {
                icon: Download,
                label: 'Inmediata'
              }, {
                icon: Clock,
                label: '5 min/día'
              }].map((item, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.5 + i * 0.1
              }} className="flex items-center gap-1 text-[var(--text-muted)] text-[10px] md:text-xs" data-id="element-361">
                    <item.icon className="w-3 h-3 md:w-3.5 md:h-3.5 text-[var(--accent)]" data-id="element-362" />
                    <span data-id="element-363">{item.label}</span>
                  </motion.div>)}
              </div>

              {/* Persuasive microcopy */}
              <p className="text-center text-xs md:text-sm text-[var(--text-primary)] mt-3 md:mt-5 font-serif italic leading-relaxed max-w-md mx-auto" data-id="element-364">
                "Ábrelo en tu celular o tablet.{' '}
                <span className="text-[var(--accent)] font-semibold not-italic" data-id="element-365">
                  5 minutos que cambian el día.
                </span>
                "
              </p>
            </div>

            {/* Bottom accent line */}
            <div className="h-[2px] bg-gradient-to-r from-transparent via-[var(--accent)]/40 to-transparent" data-id="element-366" />
          </div>
        </motion.div>
        {/* === END DEVICE MOCKUP === */}

        {/* What each encounter includes */}
        <div className="bg-[var(--bg-elevated)] rounded-xl p-4 md:p-6 mb-5 md:mb-8 border border-[var(--border-subtle)]" data-id="element-367">
          <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest text-center mb-3" data-id="element-368">
            Cada uno de los 40 encuentros incluye:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3" data-id="element-369">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-2 text-xs md:text-sm text-[var(--text-primary)]" data-id="element-370">
                <span className="text-sm flex-shrink-0" data-id="element-371">{item.icon}</span>
                <span data-id="element-372">{item.text}</span>
              </motion.div>)}
          </div>
        </div>

        {/* Discoveries */}
        <h3 className="text-lg md:text-xl font-serif text-[var(--text-heading)] text-center mb-4" data-id="element-373">
          Lo que vas a descubrir en estos 40 días:
        </h3>
        <div className="grid gap-2 md:gap-4" data-id="element-374">
          {discoveries.map((d, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-[var(--bg-elevated)] border border-[var(--border-subtle)]" data-id="element-375">
              <span className="text-lg flex-shrink-0" data-id="element-376">{d.emoji}</span>
              <div data-id="element-377">
                <p className="font-semibold text-[var(--text-heading)] text-xs md:text-sm mb-0.5" data-id="element-378">
                  {d.title}
                </p>
                <p className="text-[var(--text-muted)] text-xs md:text-sm leading-relaxed" data-id="element-379">
                  {d.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}